export default __webpack_public_path__ + "static/media/pipcorn-biz.9b0384f6.png";